import { getBars } from "@/lib/datafeed/getBars.ts";
import {
  IExtendedLibrarySymbolInfo,
  resolveSymbol,
} from "@/lib/datafeed/resolveSymbol.ts";
import { searchSymbols } from "@/lib/datafeed/searchSymbols.ts";
import {
  subscribeOnStream,
  unsubscribeFromStream,
} from "@/lib/datafeed/streaming.ts";
import {
  DatafeedErrorCallback,
  HistoryCallback,
  IDatafeedChartApi,
  IExternalDatafeed,
  LibrarySymbolInfo,
  PeriodParams,
  ResolutionString,
  SubscribeBarsCallback,
} from "@tradingView/charting_library";
import { CHART_CONFIG } from "@/lib/datafeed/config.ts";

export interface IExtendedDatafeedChartApi
  extends IDatafeedChartApi,
    IExternalDatafeed {
  getBars(
    symbolInfo: IExtendedLibrarySymbolInfo,
    resolution: ResolutionString,
    periodParams: PeriodParams,
    onResult: HistoryCallback,
    onError: DatafeedErrorCallback,
  ): void;
  subscribeBars(
    symbolInfo: IExtendedLibrarySymbolInfo,
    resolution: ResolutionString,
    onTick: SubscribeBarsCallback,
    listenerGuid: string,
    onResetCacheNeededCallback: () => void,
  ): void;
}

export const datafeed: IExtendedDatafeedChartApi = {
  onReady: (callback) => {
    setTimeout(() => callback(CHART_CONFIG));
  },
  searchSymbols,
  resolveSymbol,
  getBars,
  subscribeBars: subscribeOnStream,
  unsubscribeBars: unsubscribeFromStream,
};
